import {
  CreateScheduledETLJobBody,
  ETLJobHistoryResponse,
  ETLJobsRequest,
  ETLScheduledJobResponse,
  EditScheduledETLJobBody,
  ScheduleETLJob,
} from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['etl'] as const;

const etlApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getScheduledETLJobs: builder.query<ETLScheduledJobResponse, ETLJobsRequest>({
        query: ({ projectId, page = 1, size = 10 }) => `projects/${projectId}/schedules?page=${page}&size=${size}`,
        providesTags: tags,
      }),
      getScheduledETLJob: builder.query<ScheduleETLJob, { projectId: number; jobId: number }>({
        query: ({ projectId, jobId }) => `projects/${projectId}/schedules/${jobId}`,
        providesTags: tags,
        transformResponse: (response: { data: ScheduleETLJob }) => response.data,
      }),
      getETLJobsHistory: builder.query<ETLJobHistoryResponse, ETLJobsRequest>({
        query: ({ projectId, page = 1, size = 10, search }) =>
          `projects/${projectId}/schedules/executions?page=${page}&size=${size}${search ? `&search=${encodeURIComponent(search)}` : ''}`,
        providesTags: tags,
      }),
      deleteETLJob: builder.mutation<{ data: ScheduleETLJob }, { projectId: number; jobId: string }>({
        query: ({ projectId, jobId }) => ({
          url: `projects/${projectId}/schedules/${jobId}`,
          method: 'DELETE',
        }),
        invalidatesTags: tags,
      }),
      createScheduledJob: builder.mutation<object, CreateScheduledETLJobBody>({
        query: ({ projectId, ...body }) => ({
          url: `projects/${projectId}/schedules`,
          method: 'POST',
          body,
        }),
        invalidatesTags: tags,
      }),
      editScheduledJob: builder.mutation<object, EditScheduledETLJobBody>({
        query: ({ projectId, jobId, ...body }) => ({
          url: `projects/${projectId}/schedules/${jobId}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: tags,
      }),
      getETLJobLog: builder.infiniteQuery<
        { lines: string[]; next_token: string | null },
        { projectId: number; jobId: string; size?: number },
        number
      >({
        infiniteQueryOptions: {
          initialPageParam: 1,
          getNextPageParam: (lastPage, _allPages, lastPageParam) =>
            lastPage.next_token ? lastPageParam + 1 : undefined,
        },
        query: ({ pageParam, queryArg: { projectId, jobId } }) =>
          `projects/${projectId}/schedules/executions/${jobId}/logs?page=${pageParam}`,
        providesTags: tags,
        transformResponse: (response: { data: { lines: string[]; next_token: string | null } }) => response.data,
      }),
    }),
  });

export default etlApi;
